module.exports = __webpack_public_path__ + "static/media/icon_chat_big.bdd51cbc.svg";